export default "__VITE_ASSET__BtH7fKA$__"